// src/constants/theme.constants.ts

import {
  CheckCircle,
  Clock,
  XCircle,
  RefreshCw,
  FileText,
  ThumbsUp,
} from "lucide-react";

export const COMPANY_COLORS = {
  primary: "#0D1B3E",
  secondary: "#F5A623",
  primaryMid: "#1A2D54",
  primaryLight: "#253C6E",
  goldPale: "#FFF8EC",
  goldBorder: "rgba(245,166,35,0.25)",
  pageBg: "#F4F6FA",
  surface: "#FFFFFF",
  border: "#E2E7F0",
  textPrimary: "#0D1B3E",
  textMuted: "#6B7A9B",
  textLight: "#A0AABF",
} as const;

export const STATUS_CONFIG = {
  CONDITIONAL_OFFER_RECEIVED: {
    dotColor: "#F5A623",
    badgeBg: "#FFF8EC",
    badgeText: "#8a5a00",
    badgeBorder: "rgba(245,166,35,0.25)",
    icon: FileText,
    label: "Conditional Offer Received",
  },
  CONDITIONAL_OFFER_REFERRED: {
    dotColor: "#9333EA",
    badgeBg: "#F5F3FF",
    badgeText: "#5B21B6",
    badgeBorder: "#DDD6FE",
    icon: RefreshCw,
    label: "Conditional Offer Referred",
  },
  PENDING_CUSTOMER_DOCUMENTS: {
    dotColor: "#FB8C00",
    badgeBg: "#FFF3E0",
    badgeText: "#E65100",
    badgeBorder: "#FFE0B2",
    icon: Clock,
    label: "Pending Customer Docs",
  },
  PENDING_SIGNED_DOCUMENTS: {
    dotColor: "#1E88E5",
    badgeBg: "#E3F2FD",
    badgeText: "#1565C0",
    badgeBorder: "#BBDEFB",
    icon: FileText,
    label: "Pending Signed Docs",
  },
  PENDING_FULFILMENT: {
    dotColor: "#FB8C00",
    badgeBg: "#FFF3E0",
    badgeText: "#E65100",
    badgeBorder: "#FFE0B2",
    icon: Clock,
    label: "Pending Fulfilment",
  },
  COMPLETED: {
    dotColor: "#43A047",
    badgeBg: "#E8F5E9",
    badgeText: "#2E7D32",
    badgeBorder: "#C8E6C9",
    icon: CheckCircle,
    label: "Completed",
  },
  REJECTED: {
    dotColor: "#EF5350",
    badgeBg: "#FDECEA",
    badgeText: "#C62828",
    badgeBorder: "#FFCDD2",
    icon: XCircle,
    label: "Rejected",
  },
  REJECTED_FINAL_OFFER: {
    dotColor: "#EF5350",
    badgeBg: "#FDECEA",
    badgeText: "#C62828",
    badgeBorder: "#FFCDD2",
    icon: XCircle,
    label: "Rejected Final Offer",
  },
  FINAL_OFFER_RECEIVED: {
    dotColor: "#43A047",
    badgeBg: "#E8F5E9",
    badgeText: "#2E7D32",
    badgeBorder: "#C8E6C9",
    icon: CheckCircle,
    label: "Final Offer Received",
  },
  DOCUMENT_SUBMITTED: {
    dotColor: "#1E88E5",
    badgeBg: "#E3F2FD",
    badgeText: "#1565C0",
    badgeBorder: "#BBDEFB",
    icon: FileText,
    label: "Document Submitted",
  },
  APPROVED: {
    dotColor: "#43A047",
    badgeBg: "#E8F5E9",
    badgeText: "#2E7D32",
    badgeBorder: "#C8E6C9",
    icon: ThumbsUp,
    label: "Approved",
  },
  PROCESSING: {
    dotColor: "#5C6BC0",
    badgeBg: "#E8EAF6",
    badgeText: "#283593",
    badgeBorder: "#C5CAE9",
    icon: RefreshCw,
    label: "Processing",
  },
} as const;